module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/X-Men-Days-of-Future-Past.2a46f29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/X-Men-Days-of-Future-Past.jpg
// module id = ENzN
// module chunks = 0